<template>
  <div v-if="currentFilters" class="filters">
    <button
      v-if="competitionData.competition[0].penalties"
      class="stage-btn"
      v-bind:class="[{ active: afterStage }, 'after-stage-button']"
      @click="$emit('switch-penalties')"
    >
      <span v-if="afterStage">{{ $t("afterStage") }}</span>
      <span v-else>{{ $t("onStage") }}</span>
    </button>
    <div v-for="(filter, index) in restrictedFilters" :key="index" class="section">
      <Dropdown v-if="filter.list.length" fullwidth>
        <button class="filter" type="button">
          <div class="filter__label">
            {{ filter.title }}
          </div>
          <div v-if="suggestions[index] && currentFilters[index].default" class="filter__suggestion">
            {{ $t("everybody") + ": " + suggestions[index] }}
          </div>
          <div v-else-if="currentFilters[index]" class="filter__value">
            {{ currentFilters[index].name }}
          </div>
        </button>

        <template #content>
          <ul class="menu">
            <li v-for="(value, valueIndex) in filter.list" :key="valueIndex" class="item">
              <button class="link" @click="setFilter(index, filter.key, value)">
                {{ value.name }}
              </button>
            </li>
          </ul>
        </template>
      </Dropdown>
    </div>

    <button class="collapse-button" @click="toggleDetails">
      {{ collapsedAll ? $t("expandDetails") : $t("collapseDetails") }}
    </button>
    <button class="clear-filters" @click="clearFilters">{{ $t("clearFilters") }}</button>

    <!--    <div class="section">-->
    <!--      <button class="btn" type="button">Offline</button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown.vue"

export default {
  name: "Filters",
  components: {
    Dropdown,
  },

  props: {
    competitionData: Object,
    filters: Array,
    currentFilters: Array,
    afterStage: Boolean,
    collapsedAll: Boolean,
  },

  data: () => ({
    suggestions: [],
    restrictedFilters: [],
    isOnStage: false,
  }),

  computed: {
    // restrictedFilters: function(){
    //   let restrictedFilters = []
    //   for(let o of this.filters)
    //     restrictedFilters.push(o)
    //   for(let index in this.filters){
    //     const currentFilter = this.currentFilters[index];
    //     if(currentFilter)
    //       switch (this.filters[index].key){
    //         case 'category':
    //           if(!currentFilter.default){
    //             console.log("TEST");
    //             const groupIndex = this.getFilterIndexByKey('group')
    //             restrictedFilters[groupIndex].list = restrictedFilters[groupIndex].list.filter(
    //               (result) =>
    //                 result.default === true || result.categoryId === currentFilter.categoryId
    //             )
    //             const groupIdList = restrictedFilters[groupIndex].list.map((group) => group.groupId)
    //             const classIndex = this.getFilterIndexByKey('class')
    //             restrictedFilters[classIndex].list = restrictedFilters[classIndex].list.filter(
    //               (result) =>
    //                 result.default === true || groupIdList.includes(result.groupId)
    //             )
    //           }
    //           break;
    //         // case 'group':
    //         //   if(currentFilter.groupId)
    //         //     filteredResults = filteredResults.filter(
    //         //       (result) =>
    //         //         result.championshipParticipation[this.currentChampionship.championshipId].groupId === currentFilter.groupId
    //         //     )
    //         //   break;
    //         // case 'class':
    //         //   if(currentFilter.classId)
    //         //     filteredResults = filteredResults.filter(
    //         //       (result) =>
    //         //         result.championshipParticipation[this.currentChampionship.championshipId].classId === currentFilter.classId
    //         //     )
    //         //   break;
    //         // case 'specialClassification':
    //         //   if(currentFilter.specialClassificationId)
    //         //     filteredResults = filteredResults.filter(
    //         //       (result) =>
    //         //         result.championshipParticipation[this.currentChampionship.championshipId].specialIds.includes(currentFilter.specialClassificationId)
    //         //     )
    //         //   break;
    //       }
    //   }
    //   return restrictedFilters;
    // }
  },
  watch: {
    currentFilters: {
      deep: true,
      handler() {},
    },
    filters: {
      deep: true,
      handler() {
        this.copyFilters()
      },
    },
  },
  mounted: function () {
    this.copyFilters()
  },
  methods: {
    setFilter: function (index, key, value) {
      this.currentFilters.splice(index, 1, value)
      const currentFilter = this.currentFilters[index]
      const categoryIndex = this.getFilterIndexByKey("category")
      const groupIndex = this.getFilterIndexByKey("group")
      const classIndex = this.getFilterIndexByKey("class")
      if (categoryIndex >= 0 && groupIndex >= 0 && classIndex >= 0) {
        const currentCategoryFilter = this.currentFilters[categoryIndex]
        const currentGroupFilter = this.currentFilters[groupIndex]
        const currentClassFilter = this.currentFilters[classIndex]
        const categoryFilters = this.filters[categoryIndex]
        const groupFilters = this.filters[groupIndex]
        const classFilters = this.filters[classIndex]
        switch (key) {
          case "category":
            if (currentFilter.default) {
              this.restrictedFilters[groupIndex] = groupFilters
              if (currentGroupFilter.default) {
                this.restrictedFilters[classIndex] = classFilters
              }
            } else {
              this.clearSelectedFilter("specialClassification")
              this.restrictedFilters[groupIndex] = {
                flags: groupFilters.flags,
                key: groupFilters.key,
                title: groupFilters.title,
                list: groupFilters.list.filter(
                  (result) => result.default === true || result.categoryId === currentFilter.id
                ),
              }
              const groupIdList = this.restrictedFilters[groupIndex].list.map((group) => group.groupId)
              this.restrictedFilters[classIndex] = {
                flags: classFilters.flags,
                key: classFilters.key,
                title: classFilters.title,
                list: classFilters.list.filter(
                  (result) => result.default === true || groupIdList.includes(result.groupId)
                ),
              }
              if (currentCategoryFilter.name !== this.suggestions[categoryIndex]) {
                this.suggestions[categoryIndex] = null
                this.suggestions[groupIndex] = null
                this.clearSelectedFilter("group")
                this.clearSelectedFilter("class")
              }
            }
            break
          case "group":
            if (currentFilter.default) {
              if (currentClassFilter.default) this.suggestions[categoryIndex] = null
              if (currentCategoryFilter.default) this.restrictedFilters[classIndex] = classFilters
            } else {
              this.clearSelectedFilter("specialClassification")
              const suggestedCategory = categoryFilters.list.find(
                (category) => category.id === currentFilter.categoryId
              )
              if (suggestedCategory) this.suggestions[categoryIndex] = suggestedCategory.name
              this.restrictedFilters[classIndex] = {
                flags: classFilters.flags,
                key: classFilters.key,
                title: classFilters.title,
                list: classFilters.list.filter(
                  (result) => result.default === true || result.groupId === currentFilter.id
                ),
              }
              if (currentGroupFilter.name !== this.suggestions[groupIndex]) {
                this.suggestions[groupIndex] = null
                this.clearSelectedFilter("class")
              }
            }
            break
          case "class":
            if (currentFilter.default) {
              this.suggestions[groupIndex] = null
              if (currentGroupFilter.default) this.suggestions[categoryIndex] = null
            } else {
              this.clearSelectedFilter("specialClassification")
              const suggestedGroup = groupFilters.list.find((group) => group.id === currentFilter.groupId)
              if (suggestedGroup) this.suggestions[groupIndex] = suggestedGroup.name

              const suggestedCategory = categoryFilters.list.find(
                (category) => category.id === suggestedGroup?.categoryId
              )
              if (suggestedCategory) this.suggestions[categoryIndex] = suggestedCategory.name
            }
            break
          case "specialClassification":
            if (!currentFilter.default) {
              this.clearSelectedFilter("category")
              this.clearSelectedFilter("group")
              this.clearSelectedFilter("class")
              this.suggestions[categoryIndex] = null
              this.suggestions[groupIndex] = null
              this.suggestions[classIndex] = null
              this.restrictedFilters[categoryIndex] = categoryFilters
              this.restrictedFilters[groupIndex] = groupFilters
              this.restrictedFilters[classIndex] = classFilters
            }
            break
        }
      }
    },
    clearSelectedFilter: function (key) {
      const index = this.getFilterIndexByKey(key)
      if (index !== -1) this.currentFilters.splice(index, 1, { name: this.$i18n.t("everybody"), default: true })
    },
    getFilterIndexByKey(key) {
      return this.filters.findIndex((filter) => filter.key === key)
    },
    copyFilters() {
      this.restrictedFilters = [...this.filters]
      let suggestionLength = this.filters.length
      this.suggestions = []
      while (suggestionLength--) this.suggestions.push(null)
    },
    clearFilters() {
      this.$emit("clear-current-filters")
      this.copyFilters()
    },
    toggleDetails() {
      this.$emit("toggle-details")
    },
  },
}
</script>

<style scoped lang="scss">
.filters {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(6rem, 0.5fr));

  .filter {
    text-align: left;
    background: inherit;
    border-radius: 0;
    display: block;
    padding: 0.5rem;
    width: 100%;
    transition: background 250ms;

    &__label {
      opacity: 0.75;
      font-size: 0.65rem;
      text-transform: uppercase;
    }

    &__value {
      font-size: 0.75rem;
      font-weight: bold;
    }

    &__suggestion {
      font-size: 0.75rem;
      font-weight: bold;
      color: #708ac9;
    }

    &:hover {
      background: rgba(#fff, 0.5);
    }
  }
}

.menu {
  .item:not(:last-of-type) {
    border-bottom: 1px solid $light;
  }

  .link {
    display: block;
    text-align: left;
    padding: 0.75rem 1rem;
    width: 100%;

    &:hover {
      background: $light;
    }
  }
}

.collapse-button {
  font-size: 0.65rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.5rem 0.5rem;
  border-radius: 0.45rem;
  border: 3px solid $light;
  margin: 0.5rem;
  transition: background 250ms;
  max-width: 6rem;
  text-align: center;
  margin-left: auto;

  &:hover {
    background: darken($light, 2.5%);
  }
}

.clear-filters {
  color: $warning;
  font-size: 0.65rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.5rem 0.5rem;
  border-radius: 0.45rem;
  border: 3px solid $light;
  margin: 0.5rem;
  transition: background 250ms;
  max-width: 6rem;
  text-align: center;
  margin-left: auto;

  &:hover {
    background: darken($light, 2.5%);
  }
}

.stage-btn {
  color: #000;
  font-weight: bold;
  padding: 0.5rem 0.5rem;
  border-radius: 0.45rem;
  border: 3px solid $light;
  margin: 0.5rem;
  transition: background 250ms;
  background: darken($light, 5%);

  &:hover {
    background: darken($light, 2.5%);
  }
}
.after-stage-button {
  border: 1px solid #5170be;
  //border: #5170be 1px solid
  border-radius: 0.45rem;
}
</style>
